import { ContactFormState } from "@/interfaces/contactUs_type";
import { ContactUsCard } from "../Cards/ContactUsCard";
import { SectionDiv } from "./Components/SectionDiv";

type ContactUsSectionProps = {
    contactUs: ContactFormState[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void
}

export function ContactUsSection(
    { contactUs, isNewCard, markAsSeen }: ContactUsSectionProps
) {
    return (
        <SectionDiv className="overflow-hidden mb-2" height="h-[22em]">
            <h3 className="text-green-700 mb-3">You have {contactUs.length} new emails that wish to contact the company:</h3>

            <div className="overflow-y-auto flex gap-2">
                {contactUs.length > 0 ? contactUs.map((contact, index) => (
                    <ContactUsCard key={index} contactUs={contact} isNew={isNewCard('contactUs', contact.email ?? '')} onView={() => markAsSeen('contactUs', contact.email ?? '')} />
                )) : <h3>No Contact Us at the moment</h3>}
            </div>
        </SectionDiv>
    );
}
